module.exports = __webpack_public_path__ + "img/4bb4ac0.jpg";